import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {
  localize
} from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr.json'

// eslint-disable-next-line import/no-extraneous-dependencies
import flatpickr from 'flatpickr'

// Install and Activate the French locale.
localize('fr', fr)

const french = require('flatpickr/dist/l10n/fr.js').default.fr

flatpickr.localize(french)

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: loadLocaleMessages(),
})